import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fd87fc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "view",
  "data-view": ""
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "box-menu" }
const _hoisted_4 = { class: "header__title" }
const _hoisted_5 = { class: "details" }
const _hoisted_6 = { class: "header__actions" }
const _hoisted_7 = { class: "box section section--about" }
const _hoisted_8 = { class: "box-menu" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Sobre o treinamento:", -1))
const _hoisted_10 = { class: "course-description" }
const _hoisted_11 = {
  key: 1,
  class: "menu-container"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Ementas do treinamento:", -1))
const _hoisted_13 = { class: "menus" }
const _hoisted_14 = { class: "divisor-align" }
const _hoisted_15 = { class: "divisor-title" }
const _hoisted_16 = {
  key: 2,
  class: "instructors-list"
}
const _hoisted_17 = {
  key: 0,
  class: "section section--instructors",
  "data-instructors": ""
}
const _hoisted_18 = { class: "box-menu" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "Instrutores:", -1))
const _hoisted_20 = ["data-instructor-index"]
const _hoisted_21 = { class: "instructor__information" }
const _hoisted_22 = { class: "instructor__name" }
const _hoisted_23 = ["data-biography"]
const _hoisted_24 = { class: "instructor__button-see" }
const _hoisted_25 = ["data-see-more", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseDetails = _resolveComponent("CourseDetails")!
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_TUIViewer = _resolveComponent("TUIViewer")!
  const _component_FakeIframe = _resolveComponent("FakeIframe")!
  const _component_CircularImage = _resolveComponent("CircularImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString($setup.trainingCourse.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_CourseDetails, {
            course: $setup.trainingCourse,
            numberOfEnrollUsers: $setup.numberOfEnrollUsers
          }, null, 8, ["course", "numberOfEnrollUsers"]),
          _createElementVNode("div", _hoisted_6, [
            false
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 0,
                  label: "Ausente",
                  type: "red",
                  disabled: true
                }))
              : _createCommentVNode("", true),
            ($setup.showIsAttendance)
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 1,
                  label: "Presente",
                  type: "green",
                  disabled: true
                }))
              : _createCommentVNode("", true),
            ($setup.showEnrollButton)
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 2,
                  label: "Inscrever-se",
                  type: "enroll",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickEnroll()))
                }))
              : _createCommentVNode("", true),
            ($setup.showUnEnrollButton)
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 3,
                  label: "Cancelar inscrição",
                  type: "enroll",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickEnroll()))
                }))
              : _createCommentVNode("", true),
            ($setup.showConfirmPresenceButton)
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 4,
                  label: "Confirmar presença",
                  type: "attendance",
                  onClick: $setup.confirmAttendance
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            ($setup.showCertificateButton && $options.isCirculoTemplate())
              ? (_openBlock(), _createBlock(_component_ActionButton, {
                  key: 5,
                  class: "header__certificate",
                  label: "Visualizar certificado",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openCertificate($setup.trainingCourse.id)))
                }))
              : _createCommentVNode("", true),
            ($setup.showCertificateButton && !$options.isCirculoTemplate())
              ? (_openBlock(), _createBlock(_component_CustomDropdown, {
                  key: 6,
                  items: $setup.dropdownCertificateItems,
                  title: "Certificação"
                }, null, 8, ["items"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_TUIViewer, {
            "model-value": $setup.trainingCourse.description
          }, null, 8, ["model-value"])
        ]),
        ($setup.trainingCourse.introductoryContent)
          ? (_openBlock(), _createBlock(_component_FakeIframe, {
              key: 0,
              introductoryContent: $setup.trainingCourse.introductoryContent
            }, null, 8, ["introductoryContent"]))
          : _createCommentVNode("", true),
        ($setup.trainingCourse.menus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.trainingCourse.menus, (menu, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString($setup.formatMenus(
                      menu.startDate,
                      menu.duration,
                      menu.startHour,
                      menu.endHour,
                      menu.title
                    )), 1)
                    ]),
                    _createVNode(_component_TUIViewer, {
                      "model-value": menu.descriptionMarkdown,
                      class: "menu-markdown"
                    }, null, 8, ["model-value"])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.instructors)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.instructors, (instructor, index) => {
                return (_openBlock(), _createBlock(_component_CircularImage, {
                  key: index,
                  position: index,
                  image: instructor.image,
                  onClick: _withModifiers(($event: any) => ($setup.goToInstructor(index)), ["prevent"])
                }, null, 8, ["position", "image", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.instructors)
      ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.instructors, (instructor, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  "data-instructor-index": index,
                  class: _normalizeClass([
              'instructor',
              { selected: $setup.selectedInstructorIndex === index }
            ])
                }, [
                  _createElementVNode("div", {
                    class: "instructor__image",
                    style: _normalizeStyle({ backgroundImage: `url(${instructor.image})` })
                  }, null, 4),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(instructor.name), 1),
                    _createElementVNode("p", {
                      "data-biography": index,
                      class: "instructor__biography"
                    }, _toDisplayString(instructor.biography), 9, _hoisted_23),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("button", {
                        "data-see-more": index,
                        class: "instructor__see-more",
                        onClick: ($event: any) => ($setup.seeMoreDescription(index))
                      }, " ver mais ", 8, _hoisted_25)
                    ])
                  ])
                ], 10, _hoisted_20))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}